















































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import CtrlClearBtn from '@/components/common/control/CtrlClearBtn.vue';
import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlResetBtn from '@/components/common/control/CtrlResetBtn.vue';
import G_140_HaisoIrai_Table from '@/components/G_kaigai/G_140_HaisoIrai_Table.vue';
import G_140_HaisoIrai_ChildHeader from '@/components/G_kaigai/G_140_HaisoIrai_ChildHeader.vue';
import G_140_HaisoIrai_BatchOrderEditing from '@/components/G_kaigai/G_140_HaisoIrai_BatchOrderEditing.vue';
import {
  OutStatus,
  SeikyusakiKb,
  SumiFlg,
  UmuFlg,
  KaigaiKobetsuKb,
  Flg,
  ChohyoShurui,
} from '@/constants/constants';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import {
  add,
  dateStrToNum,
  downloadCSVToSjis,
  formatNumber
} from '@/utils/utils';
// viewer関連
import { Viewer } from '@grapecity/activereports-vue';
// PDF出力用
import {
  PageReport,
  FontDescriptor,
  FontStore,
} from '@grapecity/activereports/core';
import { PdfExport } from '@grapecity/activereports';

const ReportKbn = {
  KOBETSU: 1,
  IKKATSU: 2,
};

const headerExportCSV = ['データ連番'
                        ,'支店コード'
                        ,'支店名'
                        ,'区分'
                        ,'区分名'
                        ,'受注日'
                        ,'集荷先コード'
                        ,'集荷先名'
                        ,'受注NO'
                        ,'着日'
                        ,'着情報'
                        ,'出荷日'
                        ,'得意先コード'
                        ,'得意先名'
                        ,'得意先住所１'
                        ,'得意先住所２'
                        ,'得意先住所３'
                        ,'納品先コード'
                        ,'納品先名'
                        ,'納品先住所１'
                        ,'納品先住所２'
                        ,'入力支店コード'
                        ,'入力支店名'
                        ,'品目コード'
                        ,'年産'
                        ,'品名'
                        ,'数量'
                        ,'端数'
                        ,'サイン'
                        ,'入庫名義'
                        ,'請求備考'
                        ,'明細備考'
                        ,'客先伝票NO'
                        ,'オーダーNO'
                        ,'事故区分'
                        ,'事故名称'
                        ,'受注明細NO'
                        ];

function getRow(item: any) {
    return [item.dataNo
           ,item.haisoIraiJigyoshoCd
           ,item.jigyoshoMei
           ,item.kbn
           ,item.kbnMei
           ,item.haisoIraiEntryYmd
           ,item.shukasakiSokoCd
           ,item.sokoMei
           ,item.haisoIraiNo
           ,item.nohinYmd
           ,item.jikanShitei
           ,item.shukkaYmd
           ,item.tokuisakiCd
           ,item.tokuisakiMei
           ,item.tokuisakiAddress1
           ,item.tokuisakiAddress2
           ,item.tokuisakiAddress3
           ,item.nohinsakiCd
           ,item.nohinsakiMei
           ,item.nohinsakiAddress1
           ,item.nohinsakiAddress2
           ,item.entryJigyoshoCd
           ,item.entryJigyoshoMei
           ,item.himmokuCd
           ,item.nensan
           ,item.himmokuMei
           ,item.haisoIraiSuryo
           ,item.haisoIraiHasu
           ,item.sing
           ,item.nyukoBiko
           ,item.haisoIraiBiko
           ,item.meisaiBiko
           ,item.tokuisakiDenpyoNo
           ,item.orderNo
           ,item.jikoKbn
           ,item.jikoMei
           ,item.haisoIraiGyoNo
           ];
  }

export default Vue.extend<any, any, any, any>({
  name: 'G_140_HaisoIrai',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlDatePicker,
    CtrlResetBtn,
    CtrlClearBtn,
    G_140_HaisoIrai_Table,
    G_140_HaisoIrai_ChildHeader,
    G_140_HaisoIrai_BatchOrderEditing,
    Viewer,
  },
  data: () => ({
    UmuFlg,
    SeikyusakiKb,
    KaigaiKobetsuKb,
    nohinYoteiYmdF: '',
    nohinYoteiYmdT: '',
    shukkaYoteiYmdF: '',
    shukkaYoteiYmdT: '',
    search: '',
    items: [],
    selected: [],
    kakuteiSumiFlg: false,
    childHeaderItem: {},
    childHeaderShow: false,
    batchOrderEditingShow: false,

    // viewer関連
    exportDialogShow: false,
    reportDataSet: '',
    reportData: '',
    reportParameter: [],
    reportType: 0,
    reportKbn: 0,
    reportTitle: '',

    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isReload: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    itemsSelected() {
      return this.selected
        .map((item: any) => ({
          haisoIraiJigyoshoCd: item.haisoIraiJigyoshoCd,
          haisoIraiEntryYmd: item.haisoIraiEntryYmd,
          haisoIraiNo: item.haisoIraiNo,
          koshinCount: item.koshinCount,
        }));
    },
    itemsSelectedKakutei() {
      return this.selected
        .filter((item: any) => item.kakuteiSumiFlg === SumiFlg.MI)
        .map((item: any) => ({
          haisoIraiJigyoshoCd: item.haisoIraiJigyoshoCd,
          haisoIraiEntryYmd: item.haisoIraiEntryYmd,
          haisoIraiNo: item.haisoIraiNo,
          koshinCount: item.koshinCount,
        }));
    },
    suryoTotal() {
      const total = this.selected.reduce(
        (total: number, item: any) =>(total = add(item.suryoSum, total)),
        0
      );
      return formatNumber({ value: total, minimumFractionDigits: 0 });
    },
    hasuTotal() {
      const total = this.selected.reduce(
        (total: number, item: any) =>(total = add(item.hasuSum, total)),
        0
      );
      return formatNumber({ value: total, minimumFractionDigits: 0 });
    },
    juryoTotal() {
      const total = this.selected.reduce(
        (total: number, item: any) =>(total = add(item.juryoSum, total)),
        0
      );
      return formatNumber({ value: total, minimumFractionDigits: 2 });
    },
  },
  methods: {
    async initValues() {
      this.nohinYoteiYmdF = this.userInfo.onlineData.genzaiYmd;
      this.nohinYoteiYmdT = '';
      this.shukkaYoteiYmdF = '';
      this.shukkaYoteiYmdT = '';
      this.search = '';
      this.nyuryokuSumiFlg = false;
      this.selected = [];
      this.items = [];
    },
    async handleReset() {
      if (await this.checkValidate()) {
        this.items = [];
        this.getData();
      }
    },
    handlClear() {
      this.initValues();
    },
    handleOKmessage() {
      if (this.messageId == 'KI_W123') {
        window.location.href = '/';
      }
      this.messageId = '';
      this.messageTextParam = [];
      this.messageShow = false;
      
      if (this.messageConfirmSubmit) {
        this.messageConfirmSubmit = false;
        this.handleExecuteCsv();
      }

    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();

      if (
        !dateStrToNum(this.nohinYoteiYmdF) &&
        !dateStrToNum(this.nohinYoteiYmdT) &&
        !dateStrToNum(this.shukkaYoteiYmdF) &&
        !dateStrToNum(this.shukkaYoteiYmdT)
      ) {
        this.messageId = 'KI_W113';
        this.messageTextParam = ['検索条件'];
        this.messageShow = true;
        return;
      }
      if (
        this.nohinYoteiYmdF &&
        this.nohinYoteiYmdT &&
        dateStrToNum(this.nohinYoteiYmdF) > dateStrToNum(this.nohinYoteiYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['納品予定日'];
        this.messageShow = true;
        return;
      }
      if (
        this.shukkaYoteiYmdF &&
        this.shukkaYoteiYmdT &&
        dateStrToNum(this.shukkaYoteiYmdF) > dateStrToNum(this.shukkaYoteiYmdT)
      ) {
        this.messageId = 'KI_W101';
        this.messageTextParam = ['出荷予定日'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      this.selected = [];
      this.$store.dispatch('common/setIsLoading', true);
      const params = {
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        kaigaiKobetsuKb: this.userInfo.kaigaiKobetsuKb,
        shiiresakiCd: this.userInfo.shiiresakiCd,
        nohinYoteiYmdF: dateStrToNum(this.nohinYoteiYmdF),
        nohinYoteiYmdT: dateStrToNum(this.nohinYoteiYmdT),
        shukkaYoteiYmdF: dateStrToNum(this.shukkaYoteiYmdF),
        shukkaYoteiYmdT: dateStrToNum(this.shukkaYoteiYmdT),
      };
      const res = await this.$store.dispatch('g140/getList', params);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        this.messageShow = true;
        this.messageId = error.messageID;
        this.messageTextParam = error.messageArgs;
        this.isReload = true;
        return;
      }
      this.items = res.data.responseData
        ? res.data.responseData.map((i: any, index: number) => ({
            ...i,
            id: `${index + 1}${i.orderNo}`,
          }))
        : [];
    },
    handleItemDetail(item: any) {
      this.childHeaderItem = item;
      this.childHeaderShow = true;
    },
    handleChildHeaderHide(reload: boolean) {
      if (reload) {
        this.getData();
      }
    },
    handleBatchOrderEditingHide(reload: boolean) {
      if (reload) {
        this.selected = [];
        this.getData();
      }
    },
    handleExportCsv() {
      this.messageConfirmSubmit = true;
      this.messageId = 'KI_Q100';
      this.messageTextParam = ["CSVを出力"];
      this.messageShow = true;
    },
    async handleExecuteCsv() {
      const rows = [...[headerExportCSV]];

      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          targetInfo: this.itemsSelected,
        },
      };
      const response = await this.$store.dispatch('g140/getCsv', payload);
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (response.data.error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = response.data.error.messageID;
          this.messageTextParam = response.data.error.messageArgs;
          this.executeFlg = false;
        } else if (response.data.error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = response.data.error.messageID;
          this.messageTextParam = response.data.error.messageArgs;
          this.executeFlg = false;
          // EXCLUSIVE_ERR の場合は以降の処理も実施
          this.handleReset();
        } else {
          this.messageShow = true;
          this.messageId = response.data.error.messageID;
          this.messageTextParam = response.data.error.messageArgs;
        }
      } else {
      
        response.data.responseData.csvData.map((item: any) =>
          rows.push(getRow(item))
        );
        
        // ファイル名
        let fileAddStr = '';
        fileAddStr += '_' + moment(new Date()).format('YYYYMMDD_HHmmss');
        
        const fileName = `出庫・配送依頼確認${fileAddStr}.csv`;

        // CSVダウンロード
        downloadCSVToSjis(rows, fileName);

      }
    },
    async handleKakutei() {

      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          targetInfo: this.itemsSelectedKakutei,
        },
      };
      const response = await this.$store.dispatch('g140/putKakutei', payload);
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (response.data.error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = response.data.error.messageID;
          this.messageTextParam = response.data.error.messageArgs;
          this.executeFlg = false;
        } else if (response.data.error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = response.data.error.messageID;
          this.messageTextParam = response.data.error.messageArgs;
          this.executeFlg = false;
          // EXCLUSIVE_ERR の場合は以降の処理も実施
          this.handleReset();
        } else {
          this.messageShow = true;
          this.messageId = response.data.error.messageID;
          this.messageTextParam = response.data.error.messageArgs;
        }
      } else {
        this.handleReset();
      }
    },
    async handleShukkoIraishoKobetsu(item: any) {
      //======================================
      // 出庫依頼書 個別出力
      //======================================

      this.reportKbn = ReportKbn.KOBETSU;
      this.reportTitle = ('00' + item.shukkaIraiJigyoshoCd).slice(-2)
                         + '_'
                         + item.shukkaIraiYmd
                         + '_'
                         + ('000000' + item.shukkaIraiNo).slice(-6)
                         + '_'
                         + item.orderNo;

      const taishoInfo : any[] = [];

      taishoInfo.push({shukkaIraiJigyoshoCd: item.shukkaIraiJigyoshoCd,
                        shukkaIraiYmd: item.shukkaIraiYmd,
                        shukkaIraiNo: item.shukkaIraiNo,
                      });

      this.handleShukkoIraisho(taishoInfo);

    },
    async handleShukkoIraishoIkkatsu() {
      //======================================
      // 出庫依頼書 一括出力
      //======================================
      
      this.reportKbn = ReportKbn.IKKATSU;
      
      let taishoItems;

      taishoItems = this.selected.filter(
        (item: any) => item.shukkoIraiMakeFlg == Flg.FLG_TRUE
      );

      if (taishoItems.length === 0) {
        return;
      }

      const taishoInfo : any[] = [];
      for (var i = 0; i < taishoItems.length; i++)
      {
        taishoInfo.push({shukkaIraiJigyoshoCd: taishoItems[i].shukkaIraiJigyoshoCd,
                         shukkaIraiYmd: taishoItems[i].shukkaIraiYmd,
                         shukkaIraiNo: taishoItems[i].shukkaIraiNo,
                        });
      }

      this.handleShukkoIraisho(taishoInfo);

    },
    async handleShukkoIraisho(taishoInfo: any) {
      //======================================
      // 出庫依頼書 出力
      //======================================

      this.reportType = ChohyoShurui.SHUKKO_IRAISHO;

      this.$store.dispatch('common/setIsLoading', true);

      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          taishoInfo: taishoInfo,
        },
      };

      const data = await this.$store.dispatch('g140/putShukkoIraisho', payload);

      this.$store.dispatch('common/setIsLoading', false);

      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = data.data.error.messageID;
        this.messageTextParam = data.data.error.messageArgs;
        this.messageShow = true;
        this.isClearTable = true;
        return;
      }
      
      this.handleReportPreview(data,);

    },
    async handleUnsoSashizushoKobetsu(item: any) {
      //======================================
      // 運送指図書 個別出力
      //======================================

      this.reportKbn = ReportKbn.KOBETSU;
      this.reportTitle = ('00' + item.haisoIraiJigyoshoCd).slice(-2)
                         + '_'
                         + item.haisoIraiEntryYmd
                         + '_'
                         + ('000000' + item.haisoIraiNo).slice(-6)
                         + '_'
                         + item.orderNo;

      const taishoInfo : any[] = [];

      taishoInfo.push({haisoIraiJigyoshoCd: item.haisoIraiJigyoshoCd,
                       haisoIraiEntryYmd: item.haisoIraiEntryYmd,
                       haisoIraiNo: item.haisoIraiNo,
                      });

      this.handleUnsoSashizusho(taishoInfo);

    },
    async handleUnsoSashizushoIkkatsu() {
      //======================================
      // 運送指図書 一括出力
      //======================================
      
      this.reportKbn = ReportKbn.IKKATSU;
      
      let taishoItems;

      taishoItems = this.selected.filter(
        (item: any) => item.haisoIraiMakeFlg == Flg.FLG_TRUE
      );

      if (taishoItems.length === 0) {
        return;
      }

      const taishoInfo : any[] = [];
      for (var i = 0; i < taishoItems.length; i++)
      {
        taishoInfo.push({haisoIraiJigyoshoCd: taishoItems[i].haisoIraiJigyoshoCd,
                         haisoIraiEntryYmd: taishoItems[i].haisoIraiEntryYmd,
                         haisoIraiNo: taishoItems[i].haisoIraiNo,
                        });
      }

      this.handleUnsoSashizusho(taishoInfo);

    },
    async handleUnsoSashizusho(taishoInfo: any) {
      //======================================
      // 運送指図書 出力
      //======================================

      this.reportType = ChohyoShurui.UNSO_SASHIZUSHO;

      this.$store.dispatch('common/setIsLoading', true);
      
      const payload = {
        requestData: {
          commonInfo: {
            jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
            genzaiYmd: this.userInfo.onlineData.genzaiYmd,
          },
          taishoInfo: taishoInfo,
        },
      };

      const data = await this.$store.dispatch('g140/putUnsoSashizusho', payload);

      this.$store.dispatch('common/setIsLoading', false);

      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = data.data.error.messageID;
        this.messageTextParam = data.data.error.messageArgs;
        this.messageShow = true;
        this.isClearTable = true;
        return;
      }

      this.handleReportPreview(data);

    },
    async handleReportPreview(data: any) {
      //======================================
      // プレビュー表示
      //======================================

      const reportName = (this.reportType == ChohyoShurui.SHUKKO_IRAISHO)
                           ? 'N_Shu032_ShukkoIraisho'
                           : 'N_Shu033_UnsoSashizusho';

      const reportResponse = await fetch(`/reports/${reportName}.rdlx-json`);
      this.exportDialogShow = true;
      const report = await reportResponse.json();

      let reportData = (this.reportType == ChohyoShurui.SHUKKO_IRAISHO)
                        ? JSON.stringify(data.data.responseData.shukkoIraiReportData)
                        : JSON.stringify(data.data.responseData.unsoSashizuReportData);

      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' + reportData;
      
      this.reportData = report;
      this.reportDataSet = await data;
      this.reportParameter = [
        { Name: 'dataString', Value: [JSON.stringify(data)] },
      ];
      if (this.$refs.reportViewer) {
        this.$refs.reportViewer
          .Viewer()
          .open(report, { ReportParams: this.reportParameter });
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          {
            name: 'ＭＳ ゴシック',
            source: '/fonts/msgothic.ttc',
            postscriptName: 'MS-Gothic',
          },
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }
    },
    async exportOrder() {
      //======================================
      // PDF出力
      //======================================

      if (this.reportKbn == ReportKbn.IKKATSU)
      {
        //一括
        const date = new Date();
        this.reportTitle = date.getFullYear()
                         + ('00' + (date.getMonth() + 1) ).slice(-2)
                         + ('00' + date.getDate()).slice(-2)
                         + '_'
                         + ('00' + date.getHours()).slice(-2)
                         + ('00' + date.getMinutes()).slice(-2)
                         + ('00' + date.getSeconds()).slice(-2);
      }

      const title = ((this.reportType == ChohyoShurui.SHUKKO_IRAISHO)
                     ? '出庫依頼書_'
                     : '運送指図書_') + this.reportTitle;

      const fileName = title;

      if (!title && !fileName) {
        console.log('不明なデータ');
        return;
      }

      const newReport = new PageReport({ language: 'jp' });
      const data = await this.reportDataSet;
      const doc = await newReport.load(this.reportData).then(() => {
        newReport.parameters['dataString'].values = [JSON.stringify(data)];
        return newReport.run();
      });
      PdfExport.exportDocument(doc, {
        info: {
          title,
        },
      })
        .then((result) => {
          result.download(fileName);
        })
        .catch(console.error);
      
      this.reportTitle = '';
      this.reportFileName = '';

    },
  },
  created() {
    if (!this.userInfo.shiiresakiCd) {
      this.messageId = 'KI_W123';
      this.messageTextParam = ['利用者マスタの仕入先が未設定の', '実行'];
      this.messageShow = true;
      return;
    }
    this.initValues();
  },
});
